import React, {createRef, useEffect, useState} from 'react';
import './TeamOrbit.scss';
import TeamMember from "./TeamMember/TeamMember";

import logo from "../../../resources/logo.svg";

import vadim from "../../../resources/our_avatars/vadim.jpg";
import tanya from "../../../resources/our_avatars/tanya.jpg";
import andrey from "../../../resources/our_avatars/andrey.jpg";
import dan from "../../../resources/our_avatars/dan.jpg";

import vika from "../../../resources/our_avatars/vika.jpg";
import alex from "../../../resources/our_avatars/alex.jpg";
import dima from "../../../resources/our_avatars/dima.jpg";
import igor from "../../../resources/our_avatars/igor.jpg";
import akshay from "../../../resources/our_avatars/akshay.jpg";

import vasili from "../../../resources/our_avatars/vasili.jpg";
import maksim from "../../../resources/our_avatars/maksim.jpg";
import nadya from "../../../resources/our_avatars/nadya.jpg";
import alena from "../../../resources/our_avatars/alena.jpg";
import lena from "../../../resources/our_avatars/lena.jpg";
import daniel from "../../../resources/our_avatars/daniel.png";
import viktor from "../../../resources/our_avatars/viktor.png";
import andrey_n from "../../../resources/our_avatars/andrey.png";

import alexandr from "../../../resources/our_avatars/alexandr.png";
import agafonov from "../../../resources/our_avatars/agafonov.png";
import toforov from "../../../resources/our_avatars/toforov.png";
import yanchenko from "../../../resources/our_avatars/yanchenko.png";

function TeamOrbit() {
    const rootRef = createRef<HTMLDivElement>();
    const [centerPos, setCenterPos] = useState(0);
    const [orbits, setOrbits] = useState([140, 275, 375]);
    const secondsForRound = [20, 33,  40];
    const [imgSize, setImgSize] = useState([55, 73, 100]);

    useEffect(() => {
        const size = Math.min(rootRef.current?.getBoundingClientRect().width || rootRef.current?.getBoundingClientRect().height || 0);
        if(size < 800) {
            setOrbits([0.175 * size, 0.34375 * size, 0.46875 * size]);
            setImgSize([0.06875 * size, 0.09125 * size, 0.125 * size]);
        }
        setCenterPos(size/2);
    }, [])

    return (
        <div ref={rootRef} className="TeamOrbit">
            <TeamMember avatar={logo} name={'Tahion.pro team'} noMove noTooltip imgHeight={29}
                        centerPos={centerPos} radius={0} secondsForRound={secondsForRound[0]} startDegree={0} imgSize={imgSize[2]}/>

            <TeamMember avatar={dan} name={'Dan Smirnov'} jobCountry={'CEO - Co-Founder, Israel'}
                        centerPos={centerPos} radius={orbits[0]} secondsForRound={secondsForRound[0]} startDegree={0} imgSize={imgSize[0]}/>
            <TeamMember avatar={tanya} name={'Tatyana Ogarkova'} jobCountry={'CPO, Belarus'}
                        centerPos={centerPos} radius={orbits[0]} secondsForRound={secondsForRound[0]} startDegree={72} imgSize={imgSize[0]}/>
            <TeamMember avatar={vadim} name={'Vadim Ogarkov'} jobCountry={'VP R&D - Co-Founder, Belarus'}
                        centerPos={centerPos} radius={orbits[0]} secondsForRound={secondsForRound[0]} startDegree={144} imgSize={imgSize[0]}/>
            <TeamMember avatar={andrey} name={'Andrey Grishman'} jobCountry={'CTO, Belarus'}
                        centerPos={centerPos} radius={orbits[0]} secondsForRound={secondsForRound[0]} startDegree={216} imgSize={imgSize[0]}/>
            <TeamMember avatar={vika} name={'Victoria Efremova'} jobCountry={'COO, Belarus'}
                        centerPos={centerPos} radius={orbits[0]} secondsForRound={secondsForRound[0]} startDegree={288} imgSize={imgSize[0]}/>

            <TeamMember avatar={alex} name={'Aleksander Karaka'} jobCountry={'PM, Belarus'} reverseWay
                        centerPos={centerPos} radius={orbits[1]} secondsForRound={secondsForRound[1]} startDegree={0} imgSize={imgSize[0]}/>
            <TeamMember avatar={dima} name={'Dmitriy Bordachev'} jobCountry={'Sr. Team Leader, Belarus'} reverseWay
                        centerPos={centerPos} radius={orbits[1]} secondsForRound={secondsForRound[1]} startDegree={90} imgSize={imgSize[0]}/>
            <TeamMember avatar={alena} name={'Aliona Pashkevich'} jobCountry={'Developer, Belarus'} reverseWay
                        centerPos={centerPos} radius={orbits[1]} secondsForRound={secondsForRound[1]} startDegree={180} imgSize={imgSize[0]}/>
            <TeamMember avatar={vasili} name={'Vasili Khapankou'} jobCountry={'Developer, Belarus'} reverseWay
                        centerPos={centerPos} radius={orbits[1]} secondsForRound={secondsForRound[1]} startDegree={270} imgSize={imgSize[0]}/>

            <TeamMember avatar={maksim} name={'Maksim Deryabin'} jobCountry={'Developer, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={0} imgSize={imgSize[0]}/>
            <TeamMember avatar={alexandr} name={'Alexandr Krupski'} jobCountry={'Developer, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={51} imgSize={imgSize[0]}/>
            {/*<TeamMember avatar={andrey_n} name={'Andrey Nosenko'} jobCountry={ 'Developer, Belarus'}*/}
            {/*            centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={90} imgSize={imgSize[0]}/>*/}
            <TeamMember avatar={yanchenko} name={'Evgeny Yanchenko'} jobCountry={'Developer, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={102} imgSize={imgSize[0]}/>
            <TeamMember avatar={agafonov} name={'Vsevolod Agafonov'} jobCountry={'QA, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={154} imgSize={imgSize[0]}/>
            <TeamMember avatar={toforov} name={'Dmitry Toforov'} jobCountry={'Developer, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={205} imgSize={imgSize[0]}/>
            <TeamMember avatar={viktor} name={'Victor Serebryakov'} jobCountry={'QA, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={257} imgSize={imgSize[0]}/>
            <TeamMember avatar={lena} name={'Elena Butko'} jobCountry={'UI Designer, Belarus'}
                        centerPos={centerPos} radius={orbits[2]} secondsForRound={secondsForRound[2]} startDegree={308} imgSize={imgSize[0]}/>
        </div>
    );
}

export default TeamOrbit;